import React, { useEffect, useRef, useState } from 'react';
import { Search } from 'lucide-react';

// Campo de busca expansível (ícone que abre o input); variantes "block" e "inline" e contador de resultados.
function ExpandableSearchFilter({
  query,
  onChange,
  placeholder = 'Buscar...',
  resultCount,
  resultLabel = 'Resultados',
  clearOnClose = true,
  variant = 'block',
}) {
  const isInline = variant === 'inline';
  const [isSearchOpen, setIsSearchOpen] = useState(Boolean(query));
  const searchInputRef = useRef(null);

  // Foca o input assim que a busca é aberta.
  useEffect(() => {
    if (isSearchOpen && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [isSearchOpen]);

  // Abre/fecha a busca; ao fechar (se clearOnClose), limpa a query para não deixar filtro invisível ativo.
  const handleToggleSearch = () => {
    setIsSearchOpen((prev) => {
      const willOpen = !prev;
      // Evita filtro ativo invisivel quando o campo e recolhido.
      if (!willOpen && clearOnClose && query) {
        onChange('');
      }
      return willOpen;
    });
  };

  return (
    <div
      className={
        isInline
          ? 'flex items-center gap-2 normal-case tracking-normal'
          : 'flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between'
      }
    >
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={handleToggleSearch}
          className={`inline-flex items-center justify-center rounded-full border border-slate-200 text-slate-500 transition hover:border-blue-200 hover:text-blue-600 ${
            isInline ? 'h-8 w-8 bg-white' : 'h-9 w-9'
          }`}
          aria-label={isSearchOpen ? 'Fechar pesquisa' : 'Abrir pesquisa'}
          title={isSearchOpen ? 'Fechar pesquisa' : 'Abrir pesquisa'}
        >
          <Search className="h-4 w-4" />
        </button>
        <div
          className={`overflow-hidden transition-all duration-200 ${
            isSearchOpen ? 'max-w-xs opacity-100' : 'max-w-0 opacity-0'
          }`}
        >
          <input
            ref={searchInputRef}
            type="text"
            placeholder={placeholder}
            value={query}
            onChange={(event) => onChange(event.target.value)}
            className={`w-56 rounded-full border border-slate-200 pl-3 pr-3 text-slate-700 placeholder:text-slate-400 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20 ${
              isInline
                ? 'bg-white py-1.5 text-xs font-medium'
                : 'bg-slate-50 py-2 text-sm sm:w-72'
            }`}
          />
        </div>
      </div>
      {typeof resultCount === 'number' ? (
        <span className={isInline ? 'whitespace-nowrap text-xs font-medium text-slate-500' : 'text-xs text-slate-500 sm:ml-auto'}>
          {resultLabel}: {resultCount}
        </span>
      ) : null}
    </div>
  );
}

export default ExpandableSearchFilter;
